import { BaseEnum } from "../../../../enums/baseEnum";

const listEthicsChannelReportType: Array<EthicsChannelReportType> = [];

export class EthicsChannelReportType extends BaseEnum {
  static ETHICS = new EthicsChannelReportType(
    1,
    "ETHICS",
    "Ética",
    "ethics",
    "Formulário Relato de Ética"
  );
  static SECURITY = new EthicsChannelReportType(
    2,
    "SECURITY",
    "Segurança",
    "security",
    "Formulário Relato de Segurança"
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public page: string,
    public title: string
  ) {
    super(id, value, label, page);
    this.title = title;
    listEthicsChannelReportType.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEthicsChannelReportType;
  }

  public static buildListEnumFromData(data: string[]): Array<BaseEnum> {
    const result: BaseEnum[] = [];
    data.forEach((item) => {
      const enumItem = this.getBy(item);
      if (enumItem) {
        result.push(enumItem);
      }
    });
    return result;
  }

  public static getBy(value: string): EthicsChannelReportType {
    return listEthicsChannelReportType.find(
      (p: EthicsChannelReportType) => p.value === value
    );
  }

  public static getPage(value: string): string {
    switch (value) {
      case EthicsChannelReportType.ETHICS.value:
        return EthicsChannelReportType.ETHICS.page;
      case EthicsChannelReportType.SECURITY.value:
        return EthicsChannelReportType.SECURITY.page;
      default:
        return "";
    }
  }

  public static getById(id: number): EthicsChannelReportType {
    return listEthicsChannelReportType.find(
      (p: EthicsChannelReportType) => p.id === id
    );
  }
}
